console.log('Google map support activated');

var MarkerClusterer = require('./markerClusterer.js');

require('./style.scss');

$(document).ready(function() {
	$(document).on('click.gmap', '.gmap-trigger', function(event) {
		event.preventDefault();
		initGMap(this);
	});
	setInterval(function(){
		$('.gmap-onload').each(function(){
			$(this).removeClass('gmap-onload');
			initGMap(this);
		})
	},1000);
});

window.GMAP_INSTANCES = {};

function initGMap(trigger) {

	// Defined vars
	// --------------------------------------------------------------
	var $trigger = $(trigger);

	var markers = $trigger.data('gmapMarkers');
	var delta = $trigger.data('gmapDelta');
	var mapstyle = $trigger.data('gmapMapstyle');
	var steps = $trigger.data('gmapSteps');
	var center = $trigger.data('gmapCenter');
	var zoom = $trigger.data('gmapZoom') ? $trigger.data('gmapZoom') : 12;
	var code = $trigger.data('gmapCode') ? $trigger.data('gmapCode') : '';

	if($trigger.data('gmapContainer'))
	{
		var $container = $($trigger.data('gmapContainer'));
		var DomContainer = $container[0];
		$container.css({position:'relative'}); // need to place tooltip
		if($container.height()==0)
		{
			var mh = $container.parent().height();
			mh = mh ? mh:$container.width()*0.6;
			$container.css({minHeight:mh+'px'}); // safari fix
		}
	}
	else
	{
		console.log('initGMap fail no container set');
		return false;
	}

	if(typeof markers =='string')
		markers = eval(markers);
	if(typeof markers=='undefined')
		markers = [];

	if(typeof delta =='string')
		delta = eval(delta);
	if(typeof delta=='undefined')
		delta = {
			desktop:[0,0],
			tablet:[0,0],
			mobile:[0,0],
		};

	if(window.innerWidth>1280)
		delta = delta && delta.desktop ? delta.desktop : [0,0];
	else if(window.innerWidth>980)
		delta = delta && delta.tablet ? delta.tablet : [0,0];
	else
		delta = delta && delta.mobile ? delta.mobile : [0,0];

	if(typeof mapstyle =='string')
		mapstyle = eval(mapstyle);
	if(typeof mapstyle=='undefined')
		mapstyle = null;

	if(typeof steps =='string')
		steps = eval(steps);
	if(typeof steps=='undefined')
		steps = [];

	var map = new google.maps.Map(DomContainer,{
		gestureHandling: "cooperative",
		styles:mapstyle,
	});

	map.DomContainer = DomContainer;
	map.hapiCode = code;
	map.hapiZoom = zoom;

	map.hapiMarkerClassUpdate = function(clusterCode){
		var clusters = window.GMAP_INSTANCES[this.hapiCode].markers;
		for(var c in clusters)
		{
			if(clusters[c].length>1)
			{
				for(var i=0; i<clusters[c].length; i++)
				{
					//console.log(clusterCode, clusters[c], clusters[c][i],clusters[c][i].hapiKey);
					if(clusters[c][i].hapiKey)
					{
						var element = map.DomContainer.querySelector('img[src*="#'+clusters[c][i].hapiKey+'"]');
						//console.log(map.DomContainer,clusters[c][i].hapiKey,element)
						if(element)
						{
							element.classList.add('gmap-marker-cluster');

							if(clusterCode && c == clusterCode)
							{
								element.classList.add('gmap-marker-cluster-active');
								element.classList.remove('gmap-marker-cluster-innactive');
							}
							else if(clusterCode)
							{
								element.classList.remove('gmap-marker-cluster-active');
								element.classList.add('gmap-marker-cluster-innactive');
							}
							else
							{
								element.classList.remove('gmap-marker-cluster-active');
								element.classList.remove('gmap-marker-cluster-innactive');
							}
						}
					}
				}
			}
		}
	}

	map.hapiZoomIn = function(clusterCode) {
		var lat = {min:null,max:null};
		var lng = {min:null,max:null};
		var clusters = window.GMAP_INSTANCES[this.hapiCode].markers;
		for(var c in clusters)
		{
			for(var i=0; i< clusters[c].length; i++)
			{
				if(c == clusterCode)
				{
					lat.min = lat.min===null ? 1*clusters[c][i].hapiData.lat : Math.min(1*clusters[c][i].hapiData.lat , lat.min);
					lng.min = lng.min===null ? 1*clusters[c][i].hapiData.lng : Math.min(1*clusters[c][i].hapiData.lng , lng.min);
					lat.max = lat.max===null ? 1*clusters[c][i].hapiData.lat : Math.max(1*clusters[c][i].hapiData.lat , lat.max);
					lng.max = lng.max===null ? 1*clusters[c][i].hapiData.lng : Math.max(1*clusters[c][i].hapiData.lng , lng.max);
				}
			}
		}

		var bounds = new google.maps.LatLngBounds({lat: lat.min, lng: lng.min},{lat: lat.max, lng: lng.max})
		this.setOptions({ maxZoom: map.hapiZoom ? map.hapiZoom:12 });
		this.fitBounds(bounds);

		setTimeout(() => map.hapiMarkerClassUpdate(clusterCode), 200);
	}

	window.GMAP_INSTANCES[code] = {
		map:map,
		markers:{},
	}

	var lat = {min:null,max:null};
	var lng = {min:null,max:null};

	// Extract overall bounds
	// --------------------------------------------------------------

	for(var i=0; i<markers.length; i++)
	{
		lat.min = lat.min===null ? 1*markers[i].lat : Math.min(1*markers[i].lat , lat.min);
		lng.min = lng.min===null ? 1*markers[i].lng : Math.min(1*markers[i].lng , lng.min);
		lat.max = lat.max===null ? 1*markers[i].lat : Math.max(1*markers[i].lat , lat.max);
		lng.max = lng.max===null ? 1*markers[i].lng : Math.max(1*markers[i].lng , lng.max);
	}
	for(var i=0; i<steps.length; i++)
	{
		lat.min = lat.min===null ? 1*steps[i].lat : Math.min(1*steps[i].lat , lat.min);
		lng.min = lng.min===null ? 1*steps[i].lng : Math.min(1*steps[i].lng , lng.min);
		lat.max = lat.max===null ? 1*steps[i].lat : Math.max(1*steps[i].lat , lat.max);
		lng.max = lng.max===null ? 1*steps[i].lng : Math.max(1*steps[i].lng , lng.max);
	}
	var bounds = new google.maps.LatLngBounds({lat: lat.min, lng: lng.min},{lat: lat.max, lng: lng.max})

	map.setOptions({ maxZoom: zoom ? zoom:12 });
	map.fitBounds(bounds);

	map.hapiReset = function(){
		this.fitBounds(bounds);
		map_recenter(this,delta[0],delta[1]);
		map.hapiMarkerClassUpdate();
	}

	setTimeout(function(map){
		map.setOptions({ maxZoom: undefined });
	}.bind(null,map),500);

	google.maps.event.addListenerOnce(map,"projection_changed", function() {
		setTimeout(function(map,delta){
			map_recenter(map,delta[0],delta[1]);
		}.bind(null,map,delta),10);
	});

	// Build Tooltip
	// --------------------------------------------------------------

	var tooltip_container_id = $container.attr('id')+'gmap-marker-tooltip';
	if($('#'+tooltip_container_id).length==0)
		$container.append('<div class="gmap-tooltip" id="'+tooltip_container_id+'" style="position:absolute;z-index:100;display:none;"></div>');

	google.maps.event.addListener(map, 'dragstart', function(){ $('#'+tooltip_container_id).hide(); });
	google.maps.event.addListener(map, 'zoom_changed', function(){ $('#'+tooltip_container_id).hide(); });

	// Build Marker Cluster
	// --------------------------------------------------------------

	var mapMarkers = [];
	for(var i=0; i<markers.length; i++)
	{
		var marker = new google.maps.Marker({
			position: {
				lat: 1*markers[i].lat,
				lng: 1*markers[i].lng
			},
			icon: GMap_icon(markers[i].type,'m'+i),
			code: markers[i].code,
			map: map,
			zIndex: 999-i,
			tooltip: markers[i].title,
			link: markers[i].link ? markers[i].link:null,
		});

		marker.hapiData = markers[i];
		marker.hapiKey = 'm'+i;

		marker.zoomIn = function() {
			map.setZoom(15);
			map.panTo(this.getPosition());
		}

		marker.doClick = function (mode='toggle') {
			$('a[href^="map://"]').removeClass('active');

			var $tooltip = $('#'+tooltip_container_id);

			if(this.tooltip)
			{
				var point = fromLatLngToPoint(this.getPosition(), map);
				$tooltip.html(this.tooltip).css({'left': point.x,'top': point.y});
				if(mode=='open' && mode!='close' || $tooltip.data('opened_marker')!=point.x+'_'+point.y)
				{
					$tooltip.data('opened_marker',point.x+'_'+point.y);
					$tooltip.show();
					//console.log('a[href^="map://'+code+':'+this.code+'"]');
					$('a[href^="map://'+code+':'+this.code+'"]').addClass('active');
				}
				else
				{
					$tooltip.data('opened_marker',null);
					$tooltip.hide();
				}
			}
			else
			{
				$tooltip.data('opened_marker',null);
				$tooltip.hide();
			}
		}

		if(!window.GMAP_INSTANCES[code].markers[markers[i].code])
			window.GMAP_INSTANCES[code].markers[markers[i].code] = [];
		window.GMAP_INSTANCES[code].markers[markers[i].code].push(marker);

		google.maps.event.addListener(marker, 'click', function(){
			if(this.link!==null)
			{
				window.location.href = this.link;
			}
			else
			{
				this.doClick()
			}
		});

		if(markers[i].cluster==1 || markers[i].type.cluster==1)
			mapMarkers.push(marker);
	}

	var markerCluster = new MarkerClusterer(map, mapMarkers, {styles:Gmap_ClusterStyles(), maxZoom:15, calculator:Gmap_ClusterCalculator});

	setTimeout(() => { map.hapiMarkerClassUpdate(); }, 500);
	setTimeout(() => { map.hapiMarkerClassUpdate(); }, 1000);

	// Build Steps and road trip
	// --------------------------------------------------------------

	var mapSteps = [];
	for(var i=0; i<steps.length; i++)
	{
		if(1*steps[i].lat+1*steps[i].lng > 0)
		{
			var marker = new google.maps.Marker({
				position: {
					lat: 1*steps[i].lat,
					lng: 1*steps[i].lng
				},
				icon: GMap_icon('step'+steps[i].i,'s'+i),
				map: map,
				zIndex: 999-i,
				tooltip: steps[i].title,
				link: steps[i].link,
			});

			google.maps.event.addListener(marker, 'click', function() {
				window.location.href = this.link;
			});

			google.maps.event.addListener(marker, 'mouseover', function () {
				var point = fromLatLngToPoint(this.getPosition(), map);
				$('#'+tooltip_container_id)
					.html(this.tooltip)
					.css({
						'left': point.x,
						'top': point.y
					})
					.show();
			});
			google.maps.event.addListener(marker, 'mouseout', function () {
				$('#'+tooltip_container_id).hide();
			});

			mapSteps.push(marker);
		}
	}
	if(mapSteps.length>0)
	{
		/*
		var directionsService = new google.maps.DirectionsService;
		var directionsDisplay = new google.maps.DirectionsRenderer({
			polylineOptions:{strokeColor:'#0c61b1',strokeOpacity:0.5,strokeWeight:6},
			suppressMarkers:true,
			preserveViewport: false,
			draggable: false,
		});
		directionsDisplay.setMap(map);

		var waypts = [];
		if(mapSteps.length>2)
		{
			var _innerSteps = mapSteps.slice(1, mapSteps.length - 1);
			for (var i = 0; i < _innerSteps.length; i++)
			{
				waypts.push({
					location: _innerSteps[i].position,
					stopover: true
				});
			}
		}

		directionsService.route(
			{
				origin: mapSteps[0].position,
				destination: mapSteps[mapSteps.length-1].position,
				waypoints: waypts,
				optimizeWaypoints: true,
				travelMode: 'DRIVING'
			},
			function(response, status) {
				if (status === 'OK') {
					directionsDisplay.setDirections(response);
				} else {
					window.alert('Directions request failed due to ' + status);
				}
			}
		);
		*/
	}

	// Save instance in shadow DOM
	// --------------------------------------------------------------

	$container.data('gmapInstance',map);
	$container.data('gmapClusterInstance',markerCluster);
	$container.data('gmapMarkers',markers);

	// Automatic zoom at level if only one marker set
	// --------------------------------------------------------------

	if(markers.length==1)
	{

		//console.log('Trying to build roadtrip from your current position to the uniq marker');
		if(false && navigator.geolocation)
		{
			setTimeout(function(){
				map = $container.data('gmapInstance');
				markers = $container.data('gmapMarkers');
				map.setZoom(zoom ? zoom : 12);
				navigator.geolocation.getCurrentPosition(GMap_itinerary.bind(null,map,markers));

			},2000);
		}
		else
		{
			//console.debug('ok');
			setTimeout(function(){
				map = $container.data('gmapInstance');
				map.setZoom(zoom ? zoom : 12);

			},2000);
		}
	}

	/*
	else
	{
		if(center && center.indexOf(',')>0)
		{
			center = center.split(',');
			center = {'lat':parseFloat(center[0]),'lng':parseFloat(center[1])};
			setTimeout(function(map,delta,center){
				console.log(map,delta,center);
				map.setCenter(center);
				map.setZoom(zoom ? zoom:12);
				setTimeout(function(map,delta){
					console.log(map,delta);
					map_recenter(map,delta[0],delta[1]);
				}.bind(null,map,delta),100);
			}.bind(null,map,delta,center),2000);
		}
	}
	*/
}

function Gmap_ClusterCalculator(cluster_markers,styles_count)
{
	var count = cluster_markers.length;

	if(count>5)
		return {text: count, index: 3, title: null};
	else if(count>3)
		return {text: count, index: 2, title: null};
	else
		return {text: count, index: 1, title: null};
}

function Gmap_ClusterStyles()
{
	var r = [
		{
			anchorIcon: [24, 24],
			anchorText: [0, 0],
			fontFamily:"Arial,sans-serif",
			fontStyle:"normal",
			fontWeight:"bold",
			width:64,
			height:64,
			textColor:(window.SKIN_map_cluster_sm_text ? window.SKIN_map_cluster_sm_text : 'white'),
			textDecoration:"none",
			textSize:20,
			url:require('../icon-assets/cluster.php') + '?color=' + (window.SKIN_map_cluster_sm ? encodeURIComponent(window.SKIN_map_cluster_sm) : 'EE990099') + '&size=44'
		},
		{
			anchorIcon: [24, 24],
			anchorText: [0, 0],
			fontFamily:"Arial,sans-serif",
			fontStyle:"normal",
			fontWeight:"bold",
			width:64,
			height:64,
			textColor:(window.SKIN_map_cluster_md_text ? window.SKIN_map_cluster_md_text : 'white'),
			textDecoration:"none",
			textSize:20,
			url:require('../icon-assets/cluster.php') + '?color=' + (window.SKIN_map_cluster_md ? encodeURIComponent(window.SKIN_map_cluster_md) : 'FF550099') + '&size=54'
		},
		{
			anchorIcon: [24, 24],
			anchorText: [0, 0],
			fontFamily:"Arial,sans-serif",
			fontStyle:"normal",
			fontWeight:"bold",
			width:64,
			height:64,
			textColor:(window.SKIN_map_cluster_lg_text ? window.SKIN_map_cluster_lg_text : 'white'),
			textDecoration:"none",
			textSize:20,
			url:require('../icon-assets/cluster.php') + '?color=' + (window.SKIN_map_cluster_lg ? encodeURIComponent(window.SKIN_map_cluster_lg) : 'FF000099') + '&size=62'
		}
	];

	if(SKIN_map_cluster_sm_icon &&  SKIN_map_cluster_sm_icon!=='')
	{
		r[0].url = SKIN_map_cluster_sm_icon;
	}
	if(SKIN_map_cluster_md_icon &&  SKIN_map_cluster_md_icon!=='')
	{
		r[1].url = SKIN_map_cluster_md_icon;
	}
	if(SKIN_map_cluster_lg_icon &&  SKIN_map_cluster_lg_icon!=='')
	{
		r[2].url = SKIN_map_cluster_lg_icon;
	}

	return r;
}

function GMap_icon(type,key)
{
	var icons = {
		default:require('../icon-assets/default.png'),
		'default-cluster':require('../icon-assets/default-cluster.png'),
		none:require('../icon-assets/none.png'),
		hotel:require('../icon-assets/hotel.png'),
		'hotel-cluster':require('../icon-assets/hotel-cluster.png'),
		place:require('../icon-assets/place.png'),
		'place-cluster':require('../icon-assets/place-cluster.png'),
		step1:require('../icon-assets/step1.png'),
		step2:require('../icon-assets/step2.png'),
		step3:require('../icon-assets/step3.png'),
		step4:require('../icon-assets/step4.png'),
		step5:require('../icon-assets/step5.png'),
		step6:require('../icon-assets/step6.png'),
		step7:require('../icon-assets/step7.png'),
		step8:require('../icon-assets/step8.png'),
		step9:require('../icon-assets/step9.png'),
		step10:require('../icon-assets/step10.png'),
		step11:require('../icon-assets/step11.png'),
		step12:require('../icon-assets/step12.png'),
		step13:require('../icon-assets/step13.png'),
		step14:require('../icon-assets/step14.png'),
		step15:require('../icon-assets/step15.png'),
		step16:require('../icon-assets/step16.png'),
		step17:require('../icon-assets/step17.png'),
		step18:require('../icon-assets/step18.png'),
		step19:require('../icon-assets/step19.png'),
		step20:require('../icon-assets/step20.png'),
	};

	//console.debug(type);
	if(typeof(type)=='object')
	{
		if(type.url!==null)
		{
			if(type.anchor)
			{
				// default bottom anchor
				var anchor_pad = parseInt(type.anchor_pad) || 0;
				var _a = new google.maps.Point(type.size[0]/2,type.size[1] - anchor_pad);

				switch (type.anchor)
				{
					case 'top': _a = new google.maps.Point(type.size[0]/2,0 + anchor_pad); break;
					case 'left': _a = new google.maps.Point(0 + anchor_pad,type.size[1]/2); break;
					case 'right': _a = new google.maps.Point(type.size[0] - anchor_pad,type.size[1]/2); break;
					case 'center': _a = new google.maps.Point(type.size[0]/2,type.size[1]/2); break;

					case 'top-left': _a = new google.maps.Point(0 + anchor_pad,0 + anchor_pad); break;
					case 'top-right': _a = new google.maps.Point(type.size[0] - anchor_pad,0 + anchor_pad); break;
					case 'bottom-left': _a = new google.maps.Point(0 + anchor_pad,type.size[1] - anchor_pad); break;
					case 'bottom-right': _a = new google.maps.Point(type.size[0] - anchor_pad,type.size[1] - anchor_pad); break;
				}
				return {
					url: type.url+'#'+key,
					anchor: _a,
				};
			}
			else
			{
				return {
					url: type.url+'#'+key,
					/*size: new google.maps.Size(type.size[0],type.size[1]),
					scaledSize: new google.maps.Size(type.size[0],type.size[1]),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(type.size[0]/2,type.size[1]/2),
					*/
				};
			}
		}
		else
		{
			type='default';
		}
	}

	var icon = icons.default;
	if(icons[type] != undefined)
		icon = icons[type];

	if(type.indexOf('-cluster')>=0) // les icones de cluster ont un format spécial
	{
		return {
			cluster:1,
			url: icon+'#'+key,
			size: new google.maps.Size(16,16),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(8, 8),
		};
	}
	else
	{
		return {
			url: icon+'#'+key,
			size: new google.maps.Size(32,34),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(16, 32),
		};
	}
}

// need to be executed from an HTTPS website

function GMap_itinerary(map,markers,position) {
	//console.debug(markers);

	var directionsDisplay = new google.maps.DirectionsRenderer();
	var directionsService = new google.maps.DirectionsService();

	directionsDisplay.setMap(map);
	directionsDisplay.setOptions( { suppressMarkers: true } );

	var infopos = "Your current position is  :\n";
	infopos += "Latitude : "+position.coords.latitude +"\n";
	infopos += "Longitude: "+position.coords.longitude+"\n";
	infopos += "Altitude : "+position.coords.altitude +"\n";
	//console.debug(infopos);

	var start = {lat: position.coords.latitude, lng: position.coords.longitude};
	var end = { 'lat': 1*markers[0].lat, 'lng': 1*markers[0].lng };
	//console.debug(start,end);
	var request = {
	origin:start,
	destination:end,
	travelMode: google.maps.TravelMode.DRIVING
	};
	directionsService.route(request, function(result, status) {
		if (status == google.maps.DirectionsStatus.OK) {
			directionsDisplay.setDirections(result);
		}
	});
}

function fromLatLngToPoint(latLng, map) {
    var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
    var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
    var scale = Math.pow(2, map.getZoom());
    var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
    return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
}

function map_recenter(_map,offsetx,offsety,latlng) {
	offsetx = window.innerWidth * offsetx/100;
	offsety = window.innerHeight * offsety/100;
    var point1 = _map.getProjection().fromLatLngToPoint(
        (latlng instanceof google.maps.LatLng) ? latlng : _map.getCenter()
    );
    var point2 = new google.maps.Point(
        ( (typeof(offsetx) == 'number' ? offsetx : 0) / Math.pow(2, _map.getZoom()) ) || 0,
        ( (typeof(offsety) == 'number' ? offsety : 0) / Math.pow(2, _map.getZoom()) ) || 0
    );
    _map.setCenter(_map.getProjection().fromPointToLatLng(new google.maps.Point(
        point1.x - point2.x,
        point1.y + point2.y
    )));
}